// services/simulacao/simulacao.service.ts

import { API } from "../api";
import type {
  OpcoesSimulacaoResponse,
  SimulacaoPayload,
  SimulacaoResultado,
} from "./simulacao.types";

/**
 * Origens/destinos/moedas suportados pelo simulador.
 * GET /api/simulacao/opcoes
 *
 * Vem do backend em vez de uma constante local porque a lista de origens
 * depende das contas UPS/FedEx configuradas lá.
 */
export const getOpcoesSimulacao = async (): Promise<OpcoesSimulacaoResponse> => {
  const { data } = await API.get<OpcoesSimulacaoResponse>(
    "/api/simulacao/opcoes",
  );

  return data;
};

/**
 * Roda a simulação de frete + impostos.
 * POST /api/simulacao
 *
 * Não cria cotação nem grava nada: é só estimativa.
 */
export const simularEnvio = async (
  payload: SimulacaoPayload,
): Promise<SimulacaoResultado> => {
  const { data } = await API.post<SimulacaoResultado>(
    "/api/simulacao",
    payload,
  );

  return data;
};

/** Mensagem de erro da API de simulação, com fallback legível. */
export const mensagemErroSimulacao = (err: unknown): string => {
  const apiMsg = (err as { response?: { data?: { error?: string } } })?.response
    ?.data?.error;

  if (apiMsg) return apiMsg;

  return "Não foi possível simular agora. Tente novamente em instantes.";
};
